<template>
  <a class="hyperlink" :href="href" target="_blank">
    <slot></slot>
  </a>
</template>

<script>
export default {
  props: {
    href: {
      type: String,
      default: ""
    }
  }
}
</script>

<style scoped>
.hyperlink {
  color: #20A8C3;
  text-decoration: underline;
}
</style>